<template>
  <div v-observe-visibility="refresh">
    <div v-if="loading" class="text-center pa-5">
      <v-progress-circular width="2" color="primary" indeterminate />
    </div>
    <template v-else>
      <v-expansion-panels v-if="availablePrescriptionTypes > 1">
        <v-expansion-panel v-if="!showDontHaveService && pdfPrescriptionAvailable" popout>
          <v-expansion-panel-header>
            <h4>{{ $t('recipe.paper_recipe') }}</h4>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-layout wrap>
              <v-flex sm12 lg12>
                <Recetas :idpaciente="$route.params.id" :recetas="recetas" />
              </v-flex>
            </v-layout>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel v-if="electronicPrescriptionAvailable" popout :readonly="twoFaDisabled" @click="show2fa">
          <v-expansion-panel-header id="prescription-expand">
            <h4>{{ $t('recipe.title') }}</h4>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-layout wrap>
              <v-flex sm12 lg12>
                <TreatmentSection :patient="patient" />
              </v-flex>
            </v-layout>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <recetas v-else-if="pdfPrescriptionAvailable" :idpaciente="$route.params.id" :recetas="recetas" />
      <treatment-section v-else-if="electronicPrescriptionAvailable" :patient="patient" />
    </template>
  </div>
</template>
<script>
import Recetas from "@/components/ehealth/paciente/Recetas.vue";
import TreatmentSection from "@/components/treatments/TreatmentSection.vue";
import {haveEprescription} from "@/utils";
import {mapGetters, mapMutations, mapState} from "vuex";
import {getHeader, getPacienteUrl} from "@/config/config";
import PermissionsMixin from "@/mixins/Permissions";

export default {
  name: "PatientPrescriptions",
  components: {
    Recetas,
    TreatmentSection
  },
  mixins: [
    PermissionsMixin
  ],
  props: {
    patient: {
      type: Object,
      default: null
    },
    showDontHaveService: {
      type: Boolean,
      default: false
    },
  },
  data: function () {
    return {
      loading: false,
      showElectronicPrescription: false,
      authUser: JSON.parse(window.localStorage.getItem('auth_ehealth')),
      recetas: []
    }
  },
  computed: {
    ...mapState({
      permissions: state => state.app.permissions
    }),
    ...mapGetters({
      twoFaEnabled: 'account/twoFaEnabled',
      useNewAccountPage: 'app/getFeatureNewAccountPageFlag',
      repHomologation: 'app/getFeatureRepHomologationFlag',
    }),
    twoFaDisabled() {
      return !this.twoFaEnabled && this.useNewAccountPage && this.repHomologation;
    },

    availablePrescriptionTypes() {
      let count = 0;

      if (this.showElectronicPrescription) {
        count += 1;
      }

      if (this.permissions.prescriptions) {
        count += 1;
      }

      return count;
    },
  },
  methods: {
    ...mapMutations({
      setTwoFaDialogVisibility: 'layout/setTwoFaDialogVisibility',
    }),
    refresh(isVisible) {
      if (isVisible) {
        this.onLoad();
      }
    },
    onLoad() {
      if (
        typeof this.permissions.haveElectronicPrescription !== 'undefined' &&
        haveEprescription() &&
        !this.twoFaDisabled
      ) {
        this.showElectronicPrescription = this.permissions.haveElectronicPrescription;
      }

      if (this.pdfPrescriptionAvailable) {
        this.getPdfPrescriptions();
      }
    },
    show2fa() {
      if (this.twoFaDisabled) {
        this.setTwoFaDialogVisibility(true);
      }
    },
    async getPdfPrescriptions() {
      this.loading = true;
      const param = {
        id: this.authUser.id,
        patient_id: this.$route.params.id,
        idioma: this.$i18n.locale,
        tab: 2,
        tabkey: "recetas"
      };

      try {
        const response = await this.$http.post(getPacienteUrl, param, { headers: getHeader() });
        if (response.status === 200 && response.data) {
          this.recetas = response.data.recetas;
        }
      } catch (e) {} finally {
        this.loading = false;
      }
    },
  }
}
</script>
